import home from "../home";
var theme = home;
export default theme;